<mojo-navbar></mojo-navbar>
<div style="margin-left:1em;">
  <h1>Invalid Request</h1>
  <h3>The entity requested in URL <strong>{{previouslyRequestedUrl}}</strong> is invalid.</h3>
  <h4>(Either the entity does not exist, or your current user's limited access configuration
  doesn't allow access to it.)</h4>
  <h2><a href="/">Navigate to home page</a></h2>
</div>
